export enum AB_TESTS {
  EXAMPLE = 'abtest_example',
  QUESTS = 'abtest_le_quests',
}

export const AB_TESTS_PREFIX = 'abtest';

export const AB_TESTS_START_DATE: Partial<Record<AB_TESTS, Date>> = {
  [AB_TESTS.QUESTS]: new Date('2026-02-25'),
};
